import * as React from "react";
import { connect } from "react-redux";
import { Button, Select, Stack, Text, TextInput } from "@mantine/core";
import { addLoading } from "../../../data/actions/appointmentActions";
import { IState } from "../../../data/reducers/state";
import {
  IAppointment,
  IAppointmentDetail,
  IOfficialLoading,
} from "../../../types/appointments/Appointment";
import { BonusType } from "../../../types/payrates/bonusType";
import { CenteredLoader } from "../../common/loader";

const defaultType = BonusType.custom;

export interface IAddLoadingProps {
  toggle?: () => void;
  onSave?: () => void;
  appointmentId: string;
  appointment: IAppointment<IAppointmentDetail>;

  // from props
  actions: {
    addLoading: (
      apId: string,
      loading: IOfficialLoading,
    ) => Promise<IAppointment<IAppointmentDetail>>;
  };
}

const AddLoadingView: React.FunctionComponent<IAddLoadingProps> = ({
  actions,
  toggle,
  onSave,
  appointmentId,
  appointment,
}) => {
  const [value, setValue] = React.useState<number | string>(
    BonusType.defaultBonusForReason(
      defaultType,
      appointment?.payment?.base || 0,
    ),
  );
  const [reason, setReason] = React.useState(defaultType);
  const [comment, setComment] = React.useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const save = (_reason, _value, _comment) => {
    setIsLoading(true);
    actions
      .addLoading(appointmentId, { reason: _reason, value: Number(_value), comment: _comment })
      .then((resp) => {
        console.log(resp);
        setIsLoading(false);
        toggle?.();
        onSave?.();
      })
      .catch((er) => {
        setError(er.message);
        setIsLoading(false);
        console.log(er);
      });
  };

  const validateAndSetValue = (val: string | number) => setValue(val);
  const valueIsValid = !isNaN(Number(value)) && Number(value) > 0;
  const onBonusTypeChange = (bonusType) => {
    validateAndSetValue(
      BonusType.defaultBonusForReason(
        bonusType,
        appointment?.payment?.base || 0,
      ),
    );
    setReason(bonusType);
  };

  return (
    <div>
      <Stack gap="md" onSubmit={console.log}>
        <Stack gap="sm">
          <Text size="sm" fw={500}>Input type</Text>
          <Select
            value={reason}
            onChange={(value) => onBonusTypeChange(value || '')}
            data={BonusType.automaticReasons().map((bt) => ({
              value: bt,
              label: BonusType.toLongReason(bt)
            }))}
          />
        </Stack>
        <Stack gap="sm">
          <Text size="sm" fw={500}>Amount</Text>
          <TextInput
            leftSection="$"
            id="amount"
            type="text"
            pattern="/^\d*\.?\d*$/"
            disabled={isLoading}
            value={value}
            onChange={(e) => validateAndSetValue(e.currentTarget.value)}
          />
          <br />
          <Stack gap="sm">
            <Text size="sm" fw={500}>Comment (optional)</Text>
            <textarea
              className="form-control mt-2"
              placeholder="Comment (optional)"
              value={comment}
              onChange={(e) => setComment(e.currentTarget.value)}
            />
          </Stack>

          {error && <p color="red">{error}</p>}
          {isLoading && <CenteredLoader />}
        </Stack>

        {toggle && (
          <Button
            color="gray"
            style={{ float: "left" }}
            disabled={isLoading}
            onClick={() => toggle?.()}
          >
            Cancel
          </Button>
        )}
        <hr />
        <Button
          color="blue"
          style={{ float: "right" }}
          disabled={isLoading || !valueIsValid}
          onClick={() => save(reason, value, comment)}
        >
          Save
        </Button>
      </Stack>
      <Button color="red" onClick={() => save(BonusType.zeroPayment, 0, comment)}>
        Zero payment
      </Button>
    </div>
  );
};

function mapState2Props(
  state: IState,
  props: IAddLoadingProps,
): Partial<IAddLoadingProps> {
  return {
    appointment: state.appointments.map[props.appointmentId]!,
  };
}

function mapDispatchToProps(dispatch): Partial<IAddLoadingProps> {
  return {
    actions: {
      addLoading: (apId: string, loading: IOfficialLoading) =>
        dispatch(addLoading(apId, loading)),
    },
  };
}

export default connect(mapState2Props, mapDispatchToProps)(AddLoadingView);
